import { css, createGlobalStyle } from 'styled-components'

export const globalStyles = css`
  :root {
    --app-height: 100%;

    --bg-dark: #1caff7;
    --bg-content: #fff;
    --bg-primary: #f5f5f5;
    --bg-disabled: #eff0f4;
    --bg-fill-primary-light: #fff;

    --mobile-primary: #22242a;
    --mobile-secondary: #9ca0a7;
    --mobile-accent: #0062ff;
    --mobile-selected: #ebf3fe;
    --mobile-additional: #f3f4f6;

    --desktop-primary: #22242a;
    --desktop-secondary: #9ca0a7;
    --desktop-accent: #1caff7;
    --desktop-selected: #ebf3fe;
    --desktop-additional: #f3f4f6;

    --stroke-border: #c7c9d8;

    --border-radius-s: 4px;
    --border-radius-m: 8px;
    --border-radius-mobile: 14px;
    --border-radius-mobile-l: 50px;
    --border-radius-l: 16px;
    --border-radius-max: 50%;

    --text-on-color: #2f323c;
    --text-secondary: #6e748c;
    --text-accent: #fff;
    --text-primary: #0a0a0a;
    --text-disabled: #acacac;
    --text-brand: #1caff7;

    --primary: var(--desktop-primary);
    --secondary: var(--desktop-secondary);
    --accent: var(--desktop-accent);
    --selected: var(--desktop-selected);
    --additional: var(--desktop-additional);

    --border-radius: var(--border-radius-l);

    --surface: var(--bg-content);
    --surface-alt: var(--bg-primary);
    --border-color: var(--stroke-border);
    --shadow-sm: 1px 1px 6px 1px rgba(16, 24, 40, 0.1);
    --shadow-md: 0 4px 10px rgba(0, 0, 0, 0.25);
    --shadow-ml: 4px 4px 16px 4px rgba(84, 84, 84, 0.25);
  }

  @media (max-width: 639.98px) {
    :root {
      --primary: var(--mobile-primary);
      --secondary: var(--mobile-secondary);
      --accent: var(--mobile-accent);
      --selected: var(--mobile-selected);
      --additional: var(--mobile-additional);
      --border-radius: var(--border-radius-mobile);
    }
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  * {
    min-width: 0;
    min-height: 0;
  }

  html {
    font-size: 62.5%;
  }

  html,
  body,
  #root {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  #root {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  body {
    font-family:
      'Open Sans', 'Roboto', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
    width: 100vw;
    height: 100vh;
    font-size: 1.6rem;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html,
  body {
    overscroll-behavior-y: none;
  }
  body {
    position: fixed;
    overflow: hidden;
  }

  html,
  body,
  #root,
  #modals {
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    height: var(--app-height);
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: var(--accent);
  }
`

export const GlobalStyles = createGlobalStyle`${globalStyles}`

export default globalStyles
